/* eslint-disable */
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Button, TextField } from '@mui/material';
import { connect } from 'react-redux';
import { notificationServices } from '../../../Services';
import { BackdropLoader } from '../../../Components/Loaders';
import { CreatePageHeader } from '../../../Components/Headers';
import { Label } from '@/Components/ui/label';
import QualityConfig from '@/Components/AddProductParameters/qualityConfig';
import QualityCheck from '@/Components/AddProductParameters/qualityCheck';
import AddParameterComp from '@/Components/AddProductParameters/addParameterComp';
import ProductParametersModal from '@/Components/Modals/ProductParametersModal/productParametersModal';
import AddParameterModal from '@/Components/Modals/ProductParametersModal/AddParameterModal';
import { modalActions } from '../../../Actions';
import masterMenuServices from '@/Services/ProductSpecificationParamServices/productMasterMenu.services';
import departmentServices from '../../../Services/DepartmentServices/departmentServices';
import { urls } from '@/Constants';
import { AlertModal } from '@/Components/Modals';

const DEFAULT_QUALITY_CHECK = {
	qualityCheckEnabled: true,
	categoryConfiguration: false,
	minSamplingQuantity: 0,
	weightCheck: false,
	temperatureCheck: {
		enabled: false,
		minTemp: 0,
		maxTemp: 0,
	},
	defectCheck: {
		enabled: false,
		areaThreshold: 0,
		countThreshold: 0,
		reject: 'both',
	},
};

function CreateDepartmentPage(props) {
	const { toggleProductParametersModal, toggleAddQualityParameterModal, toggleAlertModal } = props;

	const history = useHistory();

	// Parse query params
	const searchParams = new URLSearchParams(window.location.search);
	const isEdit = searchParams.get('isEdit') === 'true';
	const isView = searchParams.get('isView') === 'true';
	const departmentId = searchParams.get('id');
	const role = searchParams.get('userRole');

	const [loading, setLoading] = useState(false);
	const [fields, setFields] = useState({
		name: '',
		description: '',
		managerName: '',
		location: '',
	});
	const [qualityCheck, setQualityCheck] = useState(DEFAULT_QUALITY_CHECK);
	const [newList, setNewList] = useState([]);
	const [showError, setShowError] = useState(false);
	const [trueFetchProductParameters, settrueFetchProductParameters] = useState(false);

	// ---------- Fetch department on edit ----------
	useEffect(() => {
		if ((isEdit || isView) && departmentId) {
			fetchDepartment();
		}
	}, [isEdit, isView, departmentId]);

	const fetchDepartment = async () => {
		setLoading(true);
		try {
			const response = await departmentServices.getDepartment({ id: departmentId, userRole: role });
			if (response?.statusCode === 200) {
				const dept = response?.data;
				setFields({
					name: dept?.userRole || '',
					description: dept?.description || '',
					managerName: dept?.managerName || '',
					location: dept?.location || '',
				});
				setQualityCheck(dept?.qualityCheck || DEFAULT_QUALITY_CHECK);
				setNewList(dept?.parameters || []);
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.errorMessage || 'Could not load department',
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Something went wrong while fetching department',
			});
		} finally {
			setLoading(false);
		}
	};

	// ---------- Field handlers ----------
	const handleInput = (e) => {
		const { name, value } = e.target;
		setFields((prev) => ({ ...prev, [name]: value }));
	};

	// ---------- Quality Parameters ----------
	const fetchProductParameters = async () => {
		try {
			const response = await masterMenuServices.productMasterMenuList({
				parameterFor: 'ROLE'
			});
			if (response?.statusCode === 200) {
				return response?.data;
			}
		} catch (error) {
			console.log(error);
		}
		return [];
	};

	const handleOpenModal = async () => {
		const productParameters = await fetchProductParameters();
		toggleProductParametersModal(true, productParameters);
	};

	const handleRemove = (id) => {
		toggleAlertModal(true, {
			title: 'Remove Parameter',
			message: 'Are you sure you want to remove this parameter?',
			handleConfirm: async () => {
				setLoading(true);
				const response = await departmentServices.deleteParameterDepartment({
					roleId: departmentId,
					parameterId: id,
				});
				if (response?.statusCode === 200) {
					setNewList((prev) => prev.filter((p) => p.id !== id));
					toggleAlertModal(false);
					notificationServices.generateNotification({
						type: 'success',
						message: response?.message || 'Parameter removed successfully',
					});
					setLoading(false);
				} else {
					notificationServices.generateNotification({
						type: 'error',
						message: response?.errorMessage || 'Something went wrong',
					});
					setLoading(false);
				}
			},
		});
	};

	const handleCategoryConfiguration = (e) => {
		setQualityCheck((prev) => ({
			...prev,
			categoryConfiguration: e.target.checked,
		}));
	};

	// ---------- Save ----------
	const handleSave = async () => {
		if (!fields.name?.trim()) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Please enter Department Name',
			});
			return;
		}

		const req = {
			id: isEdit ? departmentId : undefined,
			userRole: fields.name,
			description: fields.description,
			managerName: fields.managerName,
			location: fields.location,
			qualityCheck,
			qualityParameters: newList,
		};

		setLoading(true);
		try {
			const response = isEdit
				? await departmentServices.updateDepartment(req)
				: await departmentServices.createDepartment(req);

			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message || `Department ${isEdit ? 'updated' : 'created'} successfully`,
				});
				history.goBack();
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.errorMessage || 'Something went wrong',
				});
			}
		} catch (error) {
			console.log(error);
			notificationServices.generateNotification({
				type: 'error',
				message: 'Something went wrong',
			});
		} finally {
			setLoading(false);
		}
	};

	const handleCancel = () => {
		history.goBack();
	};

	// ---------- Render ----------
	return (
		<div className='root'>
			<BackdropLoader showProgress isLoading={loading} />
			<AlertModal />

			{/* Quality Parameter picker modal */}
			<ProductParametersModal
				selectedParameters={newList}
				setSelectedParameters={setNewList}
				handleOpenAddModal={() => toggleAddQualityParameterModal(true)}
				trueFetchProductParameters={trueFetchProductParameters}
				settrueFetchProductParameters={settrueFetchProductParameters}
			/>
			<AddParameterModal
				settrueFetchProductParameters={settrueFetchProductParameters}
			/>

			<CreatePageHeader
				heading={isView ? 'View Department' : isEdit ? 'Edit Department' : 'Create Department'}
				handleSave={handleSave}
				handleCancel={handleCancel}
				showSave={!isView}
				showCancel={!isView}
				breadcrumbs={[
					{ link: `${urls.EXTENSION}${urls.DEPARTMENTS}`, name: 'My Departments' },
					{
						link: '',
						name: isView
							? `View ${fields.name}`
							: isEdit
								? `Edit ${fields.name}`
								: 'Create New',
					},
				]}
				showBreadcrumbs
			/>

			{/* ─── Basic Info ─── */}
			<div className='p-6 flex flex-col gap-6'>
				{/* <p className='text-xl font-semibold text-gray-700 border-b pb-2'>Basic Information</p> */}

				<div className='grid grid-cols-2 gap-6'>
					<div className='flex flex-col gap-1'>
						<Label className='text-gray-600'>
							Department Name <span className='text-red-500'>*</span>
						</Label>
						<TextField
							variant='outlined'
							size='small'
							name='name'
							value={fields.name}
							onChange={handleInput}
							placeholder='e.g. Quality Assurance'
							fullWidth
							disabled={isView}
						/>
					</div>

					{/* <div className='flex flex-col gap-1'>
						<Label className='text-gray-600'>Manager Name</Label>
						<TextField
							variant='outlined'
							size='small'
							name='managerName'
							value={fields.managerName}
							onChange={handleInput}
							placeholder='e.g. John Doe'
							fullWidth
						/>
					</div> */}

					{/* <div className='flex flex-col gap-1'>
						<Label className='text-gray-600'>Location</Label>
						<TextField
							variant='outlined'
							size='small'
							name='location'
							value={fields.location}
							onChange={handleInput}
							placeholder='e.g. Floor 2, Block A'
							fullWidth
						/>
					</div> */}

					{/* <div className='flex flex-col gap-1'>
						<Label className='text-gray-600'>Description</Label>
						<TextField
							variant='outlined'
							size='small'
							name='description'
							value={fields.description}
							onChange={handleInput}
							placeholder='Brief description of this department'
							fullWidth
							multiline
							rows={2}
						/>
					</div> */}
				</div>
			</div>

			{/* ─── Quality Analysis Inspection ─── mirrors ProductCreatePage L1649-1708 */}
			{/* <div className='flex gap-2 m-[1rem] mt-4 justify-between'>
				<div className='flex item-center'>
					<Label className='text-lg text-gray-600 font-medium'>
						Quality Analysis Inspection
					</Label>
				</div>
			</div> */}

			{/* <QualityConfig
				qualityCheck={qualityCheck}
				setQualityCheck={setQualityCheck}
				disableFields={qualityCheck?.qualityCheckEnabled ? false : true}
				pageName='Department'
			/> */}

			<div
				className={`transition-all duration-700 ease-in-out transform origin-top ${qualityCheck?.qualityCheckEnabled
					? 'max-h-[1000px] scale-y-100 opacity-100'
					: 'max-h-[0px] scale-y-0 opacity-0'
					}`}
			>
				{/* <QualityCheck
					qualityCheck={qualityCheck}
					setQualityCheck={setQualityCheck}
					pageName='Department'
					showEnabled={true}
					setShowError={setShowError}
				/> */}
				<AddParameterComp
					handleOpenModal={handleOpenModal}
					selectedParameters={newList}
					handleRemove={handleRemove}
					setNewList={setNewList}
					qualityCheck={qualityCheck}
					setQualityCheck={setQualityCheck}
					hideCategoryConfiguration
					handleCategoryConfiguration={handleCategoryConfiguration}
					isDisabled={isView}
				/>
			</div>
		</div>
	);
}

const mapDispatchToProps = {
	toggleProductParametersModal: modalActions.toggleProductParametersModal,
	toggleAddQualityParameterModal: modalActions.toggleAddQualityParameterModal,
	toggleAlertModal: modalActions.toggleAlert,
};

export default connect(null, mapDispatchToProps)(CreateDepartmentPage);
